import _ from 'lodash';
import * as types from '@/store/mutation-types';
import { searchParty } from '@/mixins/search-party';

const mutations = {
  [types.SET_NAV_LINK_TITLE](state, p) {
    let drp = p.drp;
    drp = searchParty.methods._goFind({
      entry: drp.links,
      value: p.activeId,
    }).found;
    drp.title = p.newTitle;
  },
  [types.SET_NAV_SCROLL_TYPE](state, p) {
    const drp = p.drp;
    drp.scrollType = p.scrollType;
    const list = drp.navClassList;
    // remove all aligned classes from the navClassList
    _.forEach(p.scrolls, (a) => {
      const cls = `drzNav-${a.value}`;
      if (list.includes(cls)) {
        const i = list.indexOf(cls);
        list.splice(i, 1);
      }
    });
    list.push(`drzNav-${p.scrollType}`);
  },
  [types.SET_NAV_SLIDE_DIRECTION](state, p) {
    const drp = p.drp;
    drp.slideDirection = p.slideDirection;
  },
  [types.SET_NAV_LOGO](state, p) {
    const drp = p.drp;
    drp.logo = p.logo;
  },
  [types.SET_NAV_LOGO_IMG](state, p) {
    const drp = p.drp;
    drp.logoImg = p.logo;
  },
  [types.SET_NAV_LINK_HREF](state, p) {
    const drp = searchParty.methods._goFind({
      entry: p.drp.links,
      value: p.linkId,
    }).found;
    // since drops trigger the change event.
    if (drp && !_.isUndefined(p.link)) {
      drp.link = p.link;
    }
  },
  [types.SET_NAV_LINK_WINDOW](state, p) {
    let drp = p.drp;
    drp = searchParty.methods._goFind({
      entry: drp.links,
      value: p.activeId,
    }).found;
    drp.newWindow = p.newWindow;
    drp.target = p.target;
  },
  [types.ADD_NAV_LINK](state, p) {
    const drp = p.drp;
    drp.links.push(p.newLink);
  },
  [types.SET_NAV_ACTIVE_LINK](state, p) {
    const drp = p.drp;
    drp.activeLink = p.activeLink;
  },
  [types.REMOVE_NAV_LINK](state, p) {
    const drp = p.drp;
    const links = drp.links;
    if (!_.isUndefined(p.parentId)) {
      const parent = searchParty.methods._goFind({
        entry: links,
        value: p.parentId,
      }).found;
      parent.subLinks.splice(p.index, 1);
    } else {
      links.splice(p.index, 1);
    }
  },
  [types.REARRANGE_NAV_LINKS](state, p) {
    const drp = p.drp;
    const links = drp.links;
    const link = searchParty.methods._goFind({
      entry: links,
      value: p.linkId,
    }).found;
    let newParent = searchParty.methods._goFind({
      entry: links,
      value: p.newParentId,
    }).found;
    let oldParent = searchParty.methods._goFind({
      entry: links,
      value: p.oldParentId,
    }).found;
    if (!newParent) {
      newParent = links;
    } else {
      newParent = newParent.subLinks;
    }
    if (!oldParent) {
      oldParent = links;
    } else {
      oldParent = oldParent.subLinks;
    }
    if (newParent === oldParent) {
      newParent.splice(p.newIndex, 0, newParent.splice(p.oldIndex, 1)[0]);
    } else {
      // remove from old parent
      oldParent.splice(p.oldIndex, 1);
      // add to new parent
      newParent.splice(p.newIndex, 0, link);
    }
  },
};

const actions = {
  setNavLogo: ({ commit }, payload) => {
    commit(types.SET_NAV_LOGO, payload);
  },
  setNavScrollType: ({ commit }, payload) => {
    commit(types.SET_NAV_SCROLL_TYPE, payload);
  },
  setNavSlideDirection: ({ commit }, payload) => {
    commit(types.SET_NAV_SLIDE_DIRECTION, payload);
  },
  setNavLogoImg: ({ commit }, payload) => {
    commit(types.SET_NAV_LOGO_IMG, payload);
  },
  setNavLinkTitle: ({ commit }, payload) => {
    commit(types.SET_NAV_LINK_TITLE, payload);
  },
  setNavLinkHref: ({ commit }, payload) => {
    commit(types.SET_NAV_LINK_HREF, payload);
  },
  setNavLinkWindow: ({ commit }, payload) => {
    payload.target = payload.newWindow ? '_blank' : '_self';
    commit(types.SET_NAV_LINK_WINDOW, payload);
  },
  addNavLink: ({ commit }, payload) => {
    commit(types.ADD_NAV_LINK, payload);
  },
  removeNavLink: ({ commit }, payload) => {
    commit(types.REMOVE_NAV_LINK, payload);
  },
  rearrangeLinks: ({ commit }, payload) => {
    commit(types.REARRANGE_NAV_LINKS, payload);
  },
  setNavActiveLink: ({ commit }, payload) => {
    commit(types.SET_NAV_ACTIVE_LINK, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/vuex.js